import { render, staticRenderFns } from "./LoginStaff.vue?vue&type=template&id=bb9479de&scoped=true"
import script from "./LoginStaff.vue?vue&type=script&lang=js"
export * from "./LoginStaff.vue?vue&type=script&lang=js"
import style0 from "./LoginStaff.vue?vue&type=style&index=0&id=bb9479de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9479de",
  null
  
)

export default component.exports